export const CUSTOM_COLOURS = {
  lightGreen: '#B3E264',
  mediumGreen: '#01B723',
  mediumWCAGGreen: '#00830F',
  darkGreen: '#37761D',
  purple: '#864898',
};

export const CUSTOM_TQ_COLOURS = {
  // these colours are in the component library but we could not pass
  // blue.275 into the chart library. It required a hexdec
  green950: '#1D581C',
  blue275: '#0D4E8A',

  // these colours are not in the component library for TQ and will be refactored when
  // the colour palette work is done
  blue66B3E3: '#66B3E3',
  blueA0C8DB: '#A0C8DB',
  grey777E86: '#777E86',
  greyF4F8F8: '#F4F8F8',
  blue072C4D: '#072C4D',
  lightGreenBDC549: '#BDC459',
  darkGreen2B8022: '#2B8022',
  lightBlue4CAAF0: '#4CAAF0',
  darkBlue0D4E8A: '#0D4E8A',
};
